<template>
  <div
      v-if="items.length> 0"
  >
    <div
        v-for="(item, index) in items"
        class="row mt-4"
    >
      <div
          class="d-flex"
      >
        <div
            @click.prevent="removeItem(index)"
            class="btn btn-sm btn-danger ms-auto me-2 mb-1"
        >
          <i class="bi bi-x"/>
        </div>
      </div>

      <div class="row">
        <div class="col col-3 col-md-1 mb-2">
          <div class="form-floating">
            <input
                v-model="item.count"
                @input="changeItem(item, 'count')"
                type="number"
                min="1"
                class="form-control text-end pe-2"
            />
            <label>
              {{ $t('invoice.inputs.items.count.title') }}
            </label>
          </div>
        </div>
        <div class="col col-6 col-md-2 mb-2">
          <div class="form-floating">
            <input
                v-model="item.sku"
                @input="changeItem(item, 'count')"
                type="text"
                min="1"
                class="form-control text-end pe-2"
            />
            <label>
              {{ $t('invoice.inputs.items.sku.title') }}
            </label>
          </div>
        </div>
        <div class="col col-12 col-md-9 mb-2">
          <div class="form-floating">
          <textarea
              v-model="item.description"
              placeholder="Popisek polozky"
              class="form-control"
              rows="1"
          >
          </textarea>
            <label>
              {{ $t('invoice.inputs.items.description.title') }}
            </label>
          </div>
        </div>

        <template
          v-if="isVat"
        >
          <div class="col col-3 col-md-2 mb-2">
            <div class="form-floating">
              <select
                  v-model="item.tax"
                  @change="changeItem(item, 'tax')"
                  class="form-select"
              >
                <option
                    v-for="tax in inputObj.templates.taxes"
                    :value="tax"
                >
                  {{tax.title}}
                </option>
              </select>
              <label>
                {{ $t('invoice.inputs.items.vat_select.title') }}
              </label>
            </div>
          </div>
          <div class="col col-9 col-md-9 mb-2">
            <div class="input-group mb-1 w-100">
              <div class="form-floating">
                <input
                    v-model="item.price_without_tax"
                    @input="changeItem(item, 'price_without_tax')"
                    type="number"
                    min="0"
                    placeholder="Cena bez dane"
                    class="form-control"
                    readonly="readonly"
                >
                <label>
                  {{ $t('invoice.inputs.items.price_without_tax.title') }}
                </label>
              </div>
              <span class="input-group-text">
          /
        </span>
              <div class="form-floating">
                <input
                    v-model="item.price_tax"
                    @input="changeItem(item, 'price_tax')"
                    type="number"
                    min="0"
                    placeholder="Dan"
                    class="form-control"
                    readonly="readonly"
                />
                <label>
                  {{ $t('invoice.inputs.items.tax.title') }}
                </label>
              </div>
              <span class="input-group-text">
          {{inputObj.params.currency_display}}
        </span>
            </div>
          </div>

        </template>



        <div class="col col-12 col-md-4 mb-2">
          <template
              v-if="item.count > 1"
          >
            <div class="input-group mb-1">
              <div class="form-floating">
                <input
                    v-model="item.price_item"
                    @input="changeItem(item, 'price_item')"
                    type="number"
                    min="0"
                    :step="numberStep"
                    placeholder="Cena za polozku"
                    class="form-control"
                >
                <label>
                  {{ $t('invoice.inputs.items.price_item.title') }}
                </label>
              </div>

              <span class="input-group-text">
                {{inputObj.params.currency_display}}
              </span>
            </div>
          </template>
        </div>
        <div class="col col-12 col-md-4 mb-2">
          <div
              v-if="(item.price_item *  item.count) > 0"
              class="input-group mb-1"
          >
            <div class="form-floating">
              <input
                  v-model="item.sale"
                  @input="changeItem(item, 'sale')"
                  type="number"
                  min="0"
                  :max="item.price_complete"
                  :step="numberStep"
                  placeholder="sleva"
                  class="form-control"
              >
              <label>
                {{ $t('invoice.inputs.items.sale.title') }}
              </label>
            </div>

            <span class="input-group-text">
              {{inputObj.params.currency_display}}
            </span>
          </div>
          <div v-else>
            {{ $t('invoice.inputs.sale.price_not_exist_warning') }}
          </div>
        </div>
        <div class="col col-12 col-md-4 mb-2">
          <div class="input-group mb-1">
            <div class="form-floating">
              <input
                  v-model="item.price_complete"
                  @input="changeItem(item, 'price_complete')"
                  type="number"
                  :step="numberStep"
                  placeholder="Vysledna cena"
                  class="form-control"
              >
              <label>
                {{ $t('invoice.inputs.items.price_complet.title') }}
              </label>
            </div>

            <span class="input-group-text">
              {{inputObj.params.currency_display}}
            </span>
          </div>

          <!--
          <span
              v-if="item.price_complete < 0"
              class="text-danger"
          >
            <i class="bi bi-exclamation-triangle-fill me-1"></i>

            {{ $t('invoice.inputs.price.complete_warning') }}
          </span>
          -->
        </div>
      </div>




      <!--
          <div class="col col-12 mb-1 row">
            <div class="col col-2">
              <div class="form-floating">
                <input
                    v-model="item.count"
                    @input="changeItem(item, 'count')"
                    type="number"
                    min="1"
                    class="form-control text-end pe-2"
                />
                <label>Count</label>
              </div>
            </div>
            <div
                v-if="inputObj.params.is_code"
                class="col col-2"
            >
              <input
                  v-model="item.code"
                  type="text"
                  placeholder="Kod polozky"
                  class="form-control"
              />
            </div>
            <div class="col col-9">
              <div class="form-floating">
                <textarea
                      v-model="item.description"
                      placeholder="Popisek polozky"
                      class="form-control"
                      rows="1"
                >
                </textarea>
                <label>Popis</label>
              </div>
            </div>

            <div
                class="col col-1 text-end"
            >
              <button
                  @click.prevent="removeItem(index)"
                  class="btn btn-danger"
              >
                <i class="bi bi-x"></i>
              </button>
            </div>

          </div>

          <div
              v-if="inputObj.params.is_vat"
              class="col col-12 row mb-1"
          >
            <div class="col col-sm-12 col-md-4">
              <div class="form-floating">
                <select
                  v-model="item.tax"
                  @change="changeItem(item, 'tax')"
                  class="form-select"
              >
                <option
                    v-for="tax in inputObj.templates.taxes"
                    :value="tax"
                >
                  {{tax.title}}
                </option>
              </select>
                <label>DPH</label>
              </div>
            </div>

            <div class="col col-8">


              <div class="form-floating mb-3">
                <input type="email" class="form-control" id="floatingInput" placeholder="name@example.com">
                <label for="floatingInput">Email address</label>
              </div>



          <div class="input-group mb-1 w-100">
            <div class="form-floating">
              <input
                  v-model="item.price_without_tax"
                  @input="changeItem(item, 'price_without_tax')"
                  type="number"
                  min="0"
                  placeholder="Cena bez dane"
                  class="form-control"
                  readonly="readonly"
              >
              <label>Bez dane</label>
            </div>
            <span class="input-group-text">
            /
          </span>
            <div class="form-floating">
                <input
                    v-model="item.price_tax"
                    @input="changeItem(item, 'price_tax')"
                    type="number"
                    min="0"
                    placeholder="Dan"
                    class="form-control"
                    readonly="readonly"
                />
                <label>Dan</label>
              </div>
            <span class="input-group-text">
            {{inputObj.params.currency_display}}
          </span>
          </div>
        </div>

      </div>

      <div class="col col-12 row">
          <div
            v-if="item.count > 1"
            class="col"
        >
          <div class="input-group mb-1">
            <div class="form-floating">
              <input
                  v-model="item.price_item"
                  @input="changeItem(item, 'price_item')"
                  type="number"
                  min="0"
                  :step="numberStep"
                  placeholder="Cena za polozku"
                  class="form-control"
              >
              <label>Cena za polozku</label>
            </div>

            <span class="input-group-text">
            {{inputObj.params.currency_display}}
            </span>
          </div>
        </div>

        <div class="col">
          <div
              v-if="(item.price_item *  item.count) > 0"
              class="input-group mb-1"
          >
            <div class="form-floating">
              <input
                  v-model="item.sale"
                  @input="changeItem(item, 'sale')"
                  type="number"
                  min="0"
                  :max="item.price_complete"
                  :step="numberStep"
                  placeholder="sleva"
                  class="form-control"
              >
              <label>Sleva</label>
            </div>

            <span class="input-group-text">
              {{inputObj.params.currency_display}}
            </span>
          </div>
          <div v-else>
            {{ $t('invoice.inputs.sale.price_not_exist_warning') }}
          </div>
        </div>

          <div class="col">
            <div class="input-group mb-1">
              <div class="form-floating">
                <input
                    v-model="item.price_complete"
                    @input="changeItem(item, 'price_complete')"
                    type="number"
                    min="0"
                    :step="numberStep"
                    placeholder="Vysledna cena"
                    class="form-control"
                >
                <label>Cena celkem</label>
              </div>

              <span class="input-group-text">
                {{inputObj.params.currency_display}}
              </span>
            </div>

            <span
              v-if="item.price_complete < 0"
              class="text-danger"
            >
              <i class="bi bi-exclamation-triangle-fill me-1"></i>

              {{ $t('invoice.inputs.price.complete_warning') }}
            </span>

          </div>

      </div>
       -->
    </div>

  </div>
  <div
      v-else
      class="text-danger"
  >
    ve fakture musi byt minimalne jedna polozka
  </div>

  <div
      class="row mt-3"
  >
    <div
        class="col col-12 text-center"
    >
      <div class="text-end mt-1">
        <button
            @click.prevent="addItem()"
            class="btn btn-primary"

        >
          <i class="bi bi-plus me-1"></i>
          {{ $t('invoice.inputs.add_item.title') }}
        </button>
      </div>
    </div>
  </div>

  <div
      v-if="items.length> 0"
      class="row mt-3"
  >
    <div
        class="col-md-4 offset-md-8 order"
    >
      <ul
          v-if="totalPrice.count > 0"
          class="list-group text-end"
      >
        <li class="list-group-item">
          {{inputObj.texts.table.count}}:
          {{formatPrice(totalPrice.count)}}
        </li>

        <template
            v-if="isVat"
        >
          <li
              v-if=" inputObj.params.is_vat"
              class="list-group-item"
          >
            {{inputObj.texts.table.price_net}}: {{formatPrice(roundPrice(totalPrice.price_without_tax))}} {{inputObj.params.currency_display}}
          </li>
          <li
              v-if="inputObj.params.is_vat"
              class="list-group-item"
          >
            <div>
              {{inputObj.texts.table.tax}}:
              {{formatPrice(roundPrice(totalPrice.price_tax))}} {{inputObj.params.currency_display}}
            </div>


            <table
                v-if="inputObj.params.is_vat && totalPrice.price_taxes"
                class="d-inline-block mt-2"
            >
              <tr v-for="(item, index) in totalPrice.price_taxes ">
                <td class="text-muted text-end" style="font-size: .8rem;">{{item.title}}</td>
                <td class="text-muted ps-3 text-end">{{formatPrice(roundPrice(item.value))}} {{inputObj.params.currency_display}}</td>
              </tr>
            </table>
          </li>
        </template>

        <li v-if="totalPrice.price_sale > 0" class="list-group-item">
          {{inputObj.texts.table.sale}}: {{formatPrice(roundPrice(totalPrice.price_sale))}} {{inputObj.params.currency_display}}
        </li>



        <li v-if="totalPrice.price_sale > 0" class="list-group-item">
          {{inputObj.texts.table.sale}}: {{formatPrice(roundPrice(totalPrice.price_sale))}} {{inputObj.params.currency_display}}
        </li>


        <li class="list-group-item">
          {{inputObj.texts.table.price_total}}:
          {{formatPrice(roundPrice(totalPrice.price_complete))}} {{inputObj.params.currency_display}}
        </li>
      </ul>
    </div>

    <display-debug>
      <template #debugView>
        totalPrice: {{totalPrice}}
      </template>
    </display-debug>
  </div>

<!--

  <display-debug>
    <template #debugView>
      formObj.general: {{formObj.general.inputs.display_type_id.val}}
    </template>

  </display-debug>
-->

</template>

<script>
import axios from "axios";
import multiselect  from 'vue-multiselect'
import DisplayDebug from "@/components/general/DisplayDebug.vue";
import VueMultiselect from "vue-multiselect";

export default {
  name: "InvoiceItemsInput2",
  components: {
    VueMultiselect,
    DisplayDebug,
    axios,
    multiselect,
  },
  props: {
    "inputObj": Object,
    "formObj": Object,
    "modelValue": {
      type: [Object],
      required: false,
      default: null,
    },

    "activeLang": {
      type: [String],
      required: false,
      default: null,
    },
  },
  data() {
    return {
      list: [],
      is_open: true,
      items: [],
      totalPrice: {
        'count': 0,
        'price_sale': 0,
        'price_tax': 0,
        'price_complete': 0,
        'price_without_tax': 0,
      },
      inputModel: {
      },
      isVat: false,
    }
  },
  computed: {

    numberStep() {
      return null;
      //return Math.pow(10, (-1 * this.inputObj.params.digits))
    }

  },
  created() {
    //console.log('dev.items created ', this.modelValue)
    if(
        this.modelValue != "undefined"
        && this.modelValue

    ){
      this.items = this.modelValue;
    }
  },

  mounted() {
    //console.log('dev.items  mounted ', this.modelValue)
  },

  methods: {
    addItem() {
      const item = {
        'id': null,
        'count': 1,
        'sku': null,
        'code': null,
        'description': null,
        'sale': null,
        'tax': null,
        'price_tax': null,
        'price_item': null,
        'price_complete': null,
        'price_without_tax': null,
      };
      this.items.push(item);
    },
    removeItem(index) {
      if(confirm("Opravdu chce odstranit polozku z faktury?")) {
        this.items.splice(index, 1)
      }
    },

    changeItem(item, field) {
      //console.log('dev changeItem NEW', field, item);

      if(typeof item.sale == "undefined"){
        item.sale = 0
      }

      if(
          field == 'price_complete'
          && item.count == 1
      ) {
        item.price_item = item.price_complete;
      }

      //TODO validace

      if(field == 'price_complete') {
        item.price_item = (item.price_complete + item.sale) / item.count;
        this.changeItem(item, 'tax')
        //todo call tax
      }else if (field == 'tax') {

        if(
            item.price_complete
            && item.price_complete > 0
            && item.tax
        ) {
          //console.log('dev changeItem TAX2', item.price_complete, item.tax);
          item.price_without_tax = this.roundPrice(item.price_complete / (parseInt(100 + item.tax.tax_value)/ 100));
          item.price_tax = this.roundPrice(item.price_complete - item.price_without_tax);
        }

      }else{
        item.price_complete = (item.count * item.price_item) - item.sale;
        this.changeItem(item, 'tax')
      }

    },

    roundPrice(price){
        return price.toFixed(this.inputObj.params.digits)
    },

    formatSelectItem ({ id, title, email, login }) {
      return `${title}  ${id} ${email} ${login}`
    },

    formatPrice (value) {
      if (!value) return '';

      const formattedNumber = new Intl.NumberFormat('cs-CZ', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
        useGrouping: true
      }).format(value);

      // Pokud je číslo celé (bez desetinných míst), zobrazíme ho bez desetinné části
      return value % 1 === 0 ? formattedNumber.split(',')[0] : formattedNumber;

    },

  },

  watch: {
    "inputObj": {
      handler() {
        this.inputModel = this.inputObj.val;
      },
      deep: true,
      immediate: true
    },
    "modelValue": {
      handler(newVal, oldVal) {
        if(newVal && oldVal != "undefined") {
          this.items = newVal;
        }
      },
      deep: true,
      immediate: true
    },
    "items": {
      handler(newVal, oldVal) {
        if(typeof  oldVal != "undefined") {
          this.totalPrice = {
            count: 0,
            'price_tax': 0,
            'price_sale': 0,
            'price_complete': 0,
            'price_without_tax': 0,
            'price_taxes': {},
          }
          if(this.items && this.items.length > 0) {
            if(this.inputObj.params.is_vat) {
              for(const tax of this.inputObj.templates.taxes) {
                this.totalPrice.price_taxes[tax.id] = {
                  title: tax.title,
                  value: 0
                }
              }
            }


            for(const item of this.items) {
              this.totalPrice.count += item.count;

              if(item.price_without_tax) {
                this.totalPrice.price_without_tax += parseFloat(item.price_without_tax) ;
              }
              if(item.price_tax) {
                this.totalPrice.price_tax += parseFloat(item.price_tax) ;
              }

              this.totalPrice.price_complete += parseFloat(item.price_complete);

              /*
              if(item.price_tax) {
                this.totalPrice.price_complete += parseFloat(item.price_complete);
              }
              */

              if(item.sale) {
                this.totalPrice.price_sale += parseFloat(item.sale);
              }

              if(
                  this.inputObj.params.is_vat
                  && typeof item.tax != "undefined" && item.tax
              ) {
                //console.log('watch inputObj.params.vendor_id TAX ITEM', item.tax);
                this.totalPrice.price_taxes[item.tax.id].value += parseFloat(item.price_tax);
              }
            }
          }

          //console.log('dev.items watch invoice items EMIT', newVal);
          //this.$emit('update:modelValue', newVal )

          //console.log('dev.items watch items', newVal, oldVal);
        }
      },
      deep: true,
      immediate: true
    },
    "inputModel": {
      handler(newVal, oldVal) {
        if(typeof  oldVal != "undefined") {
          this.$emit('update:modelValue', newVal );
          //console.log('dev.items watch inputModel', newVal, oldVal);
          /*
          if(newVal.id) {
            //console.log('watch inputModel ID', newVal.id);
            this.$emit('update:modelValue', newVal.id )
          }else{
            this.$emit('update:modelValue', null )
          }
          */
        }
      },
      deep: true,
      immediate: true
    },
    "formObj": {
      handler(newVal, oldVal) {
        if(typeof  oldVal != "undefined" && newVal) {
          if(
              newVal.general.inputs.raw_data
              && newVal.general.inputs.raw_data.val
              && newVal.general.inputs.raw_data.val.vendor
              //&& newVal.general.inputs.raw_data.val.vendor.is_vat
          ){
            this.isVat = newVal.general.inputs.raw_data.val.vendor.is_vat
          }else{
            this.isVat = false;
          }
        }
      },
      deep: true,
      immediate: true
    },

  },
};
</script>

